export default {
    title: 'Aviso',
    text: 'Preencha todos os campos.',
    color: 'warning'
}